module.exports = __webpack_public_path__ + "img/1566565757.361f7526.jpg";